import React from 'react';
import SettingsCard from '../../../components/structure/SettingsCard';
import UpdateOrganizationForm from './UpdateOrganizationForm';
import OrganizationContainer from '../../../state/containers/OrganizationContainer';

interface OrganizationInfoSettingsProps {
    orgContainer: OrganizationContainer
}

class OrganizationInfoSettings extends React.Component<OrganizationInfoSettingsProps> {
    render() {
        return (
            <SettingsCard title="Organization Information">
                <UpdateOrganizationForm orgContainer={this.props.orgContainer} />
            </SettingsCard>
        )
    }
}

export default OrganizationInfoSettings;